import { LiveMallSearchCategory } from '@/types/live-mall-search/types'

type LiveMallSearchCategoryAlias = 'ALL' | 'LIVE' | 'PRODUCTS' | 'VENDOR' | 'KOL'

export const LIVE_MALL_SEARCH_CATEGORY_MAP: Record<LiveMallSearchCategoryAlias, LiveMallSearchCategory> = {
  ALL: 0,
  VENDOR: 1,
  LIVE: 2,
  PRODUCTS: 3,
  KOL: 4,
}

export const ALL_PAGE_DISPLAY_NUMBER = 6
